import { render } from "./createPoster.vue?vue&type=template&id=4ec9f7d0"
import script from "./createPoster.vue?vue&type=script&lang=js"
export * from "./createPoster.vue?vue&type=script&lang=js"

import "./createPoster.vue?vue&type=style&index=0&id=4ec9f7d0&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__